import React from "react";
import FormCompnent from "../components/FormComponent";


const Form=()=>{
    return(
        <div>
        <div style={{ marginTop: '90px' }}>
            <FormCompnent/>
        </div>
        </div>
    );
}

export default Form;